import { type PartnerWithImageMap } from '@capsicum/socios-core';

export const mapPartnerToCollectiblePartner = (partner?: PartnerWithImageMap) => ({
	banner: partner?.images?.partnerBanner?.url,
	id: partner?.id,
	logo: partner?.images?.partnerLogo?.url,
	name: partner?.name,
	rewardsBackground: partner?.images?.partnerRewardsDefault?.url,
	shortCode: partner?.shortName
});
